import { Global, css } from '@emotion/react'
import { globalStyles, fontWeight, color } from '@ticketswap/solar'
import getConfig from 'next/config'

const { CDN_URL } = getConfig().publicRuntimeConfig

const styles = css`
  @font-face {
    font-family: 'Proxima Nova';
    src: url('${CDN_URL}/static/fonts/ProximaNova-RegularWeb.woff2') format('woff2'),
      url('${CDN_URL}/static/fonts/ProximaNova-RegularWeb.woff') format('woff');
    font-weight: ${fontWeight.regular};
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Proxima Nova';
    src: url('${CDN_URL}/static/fonts/ProximaNova-RegularItWeb.woff2') format('woff2'),
      url('${CDN_URL}/static/fonts/ProximaNova-RegularItWeb.woff') format('woff');
    font-weight: ${fontWeight.regular};
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Proxima Nova';
    src: url('${CDN_URL}/static/fonts/ProximaNova-SemiboldWeb.woff2') format('woff2'),
      url('${CDN_URL}/static/fonts/ProximaNova-SemiboldWeb.woff') format('woff');
    font-weight: ${fontWeight.semiBold};
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Proxima Nova';
    src: url('${CDN_URL}/static/fonts/ProximaNova-BoldWeb.woff2') format('woff2'),
      url('${CDN_URL}/static/fonts/ProximaNova-BoldWeb.woff') format('woff');
    font-weight: ${fontWeight.bold};
    font-style: normal;
    font-display: swap;
  }

  html,
  body {
    background-color: ${color.nova};
    color-scheme: light dark;
  }
`

const BaseStyles = () => {
  return <Global styles={[globalStyles, styles]} />
}

export default BaseStyles
